module.exports = __webpack_public_path__ + "static/media/dashboard.77a07dcc.svg";